import {css, useTheme} from '@mui/material';
import {
  DLSelect,
  DlMuiAutocomplete,
  DlSelectProps,
  GetStylesFunction,
  DlMuiAutocompleteOwnProps,
} from '@wallaby-ui/core';
import * as React from 'react';

type OwnProps = DlSelectProps &
  DlMuiAutocompleteOwnProps & {
    isMui?: boolean;
  };

type Props = OwnProps;

export const FilterTypeSelect: React.FC<Props> = (props) => {
  const {isMui, components, tabIndex, ...restProps} = props;

  const theme = useTheme();
  const styles = getStyles({theme});

  const muiAutocompleteComponent = (
    <div css={styles.filterWrapper}>
      <DlMuiAutocomplete
        limitTags={1}
        inputCss={styles.select}
        {...restProps}
      />
    </div>
  );

  const dlSelectComponent = (
    <div className={'dlFilterNodeContentInput'}>
      <DLSelect components={components} tabIndex={tabIndex} {...restProps} />
    </div>
  );

  return isMui ? muiAutocompleteComponent : dlSelectComponent;
};

const getStyles: GetStylesFunction = (_options) => ({
  filterWrapper: css`
    display: flex;
    margin-top: 8px;
    margin-bottom: 3px;
    width: 362px;
  `,
  select: css`
    position: relative;
    width: 100%;
  `,
});
